import { createSelector } from '@reduxjs/toolkit';

import {
    pServiceFiltersKey,
    PServiceFiltersState,
} from '@/store/polako-service-filters/polako-service-filters.actions';
import { PServiceFilterKey } from '@/types/filters';

export const selectFiltersAvailable = createSelector(
    (state: { [pServiceFiltersKey]: PServiceFiltersState }) => state[pServiceFiltersKey],
    (state: PServiceFiltersState) => state.filtersAvailable,
);

export const selectFiltersAvailableByKey = createSelector(
    (state: { [pServiceFiltersKey]: PServiceFiltersState }) => state[pServiceFiltersKey],
    (_: PServiceFiltersState, key: PServiceFilterKey) => key,
    (state: PServiceFiltersState, key: PServiceFilterKey) => state.filtersAvailable[key],
);

export const selectFiltersSelected = createSelector(
    (state: { [pServiceFiltersKey]: PServiceFiltersState }) => state[pServiceFiltersKey],
    (state: PServiceFiltersState) => state.filtersSelected,
);

export const selectFiltersSelectedByKey = createSelector(
    (state: { [pServiceFiltersKey]: PServiceFiltersState }) => state[pServiceFiltersKey],
    (_: PServiceFiltersState, key: PServiceFilterKey) => key,
    (state: PServiceFiltersState, key: PServiceFilterKey) => state.filtersSelected[key],
);

export const selectFiltersSelectedCount = createSelector(
    (state: { [pServiceFiltersKey]: PServiceFiltersState }) => state[pServiceFiltersKey],
    (state: PServiceFiltersState) =>
        Object.values(state.filtersSelected || {}).reduce((acc, fk) => acc + fk.length, 0) -
        (state.filtersSelected.countryCode ? 2 : 0), // country code length
);
